var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16V6.39478L11.2139 9.60331C11.696 9.89999 12.304 9.89999 12.7861 9.60331L18 6.39478V10.6288C18 10.8557 18.1753 11.0445 18.3977 11.0896V11.0896C18.6988 11.1505 19 10.9338 19 10.6266V6C19 5.44772 18.5523 5 18 5H6C5.44772 5 5 5.44772 5 6V16C5 16.5523 5.44772 17 6 17H12.6266C12.9338 17 13.1505 16.6988 13.0896 16.3977V16.3977C13.0445 16.1753 12.8557 16 12.6288 16H6ZM12.262 8.75165L16.7335 6H7.26652L11.738 8.75165C11.8987 8.85054 12.1013 8.85054 12.262 8.75165Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12C15.568 12 14 13.568 14 15.5C14 17.432 15.568 19 17.5 19C19.432 19 21 17.432 21 15.5C21 13.568 19.432 12 17.5 12ZM16.5515 17.0015L15.295 15.745C15.1585 15.6085 15.1585 15.388 15.295 15.2515C15.4315 15.115 15.652 15.115 15.7885 15.2515L16.8 16.2595L19.208 13.8515C19.3445 13.715 19.565 13.715 19.7015 13.8515C19.838 13.988 19.838 14.2085 19.7015 14.345L17.045 17.0015C16.912 17.138 16.688 17.138 16.5515 17.0015Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailApprove);
export default __webpack_public_path__ + "static/media/email-approve.dfd314faeee58a75e3f3959c2edd125e.svg";
export { ForwardRef as ReactComponent };